import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('clipPath', { id: 'clip-path' }),
  React.createElement('clipPath', { id: 'clip-path-3' }),
  React.createElement('path', { d: 'M22.29 2.16H9.71A1.34 1.34 0 0 0 8.37 3.5v25a1.34 1.34 0 0 0 1.34 1.34h12.58a1.34 1.34 0 0 0 1.34-1.34v-25a1.34 1.34 0 0 0-1.34-1.34zM9.67 28.5v-25h2.63v25.01zm4 0v-25h8.65v2h-5.43v1.3h5.43v2h-2.86v1.3h2.86v2h-2.86v1.3h2.85v2h-5.42v1.3h5.42v2h-2.85V20h2.84v2h-2.84v1.3h2.84v2h-5.4v1.3h5.4v2z' })
));